$(document).ready(function ($) {
    $('#load-more').on('click', function (e) {
      e.preventDefault();
  
      const button = $(this);
      const nextUrl = button.data('next-url');
  
      if (nextUrl) {
  
      button.text('Loading...').prop('disabled', true);
        $.ajax({
          url: nextUrl,
          type: 'GET',
          success: function (data) {
            const newArticles = $(data).find('#articles-wrapper').html();
            const newContent = $(newArticles); 
            $('#articles-wrapper').append(newContent);
  
  
            newContent.find('image-element').addClass('aos-init aos-animate');
  
  
            const newButton = $(data).find('#load-more');
  
            // $('#articles-wrapper').append(newArticles);
  
            if (newButton.length > 0) {
              button.data('next-url', newButton.data('next-url')).text('Load More').prop('disabled', false);
            } else {
              button.remove();
            }
  
  
          },
          error: function () {
            alert('Failed to load more articles. Please try again.');
          },
        });
      }
    });
  });
  